import {useMemo} from 'react';
import {useTable, ColumnInstance, Row} from 'react-table';
import {CustomHeaderColumn} from '../table/columns/CustomHeaderColumn';
import {CustomRow} from '../table/columns/CustomRow';
import {useQueryResponseData, useQueryResponseLoading} from '../core/QueryResponseProvider';
import {resellersColumns} from './columns/_columns';
import {Reseller} from '../core/_models';
import {ResellersListLoading} from '../components/loading/ResellersListLoading';
import {ResellersListPagination} from '../components/pagination/ResellersListPagination';
import {KTCardBody} from '../../../../../_metronic/helpers';

const ResellersTable = () => {
  const resellers = useQueryResponseData();
  const isLoading = useQueryResponseLoading();
  const data = useMemo(() => resellers, [resellers]);
  const columns = useMemo(() => resellersColumns, []);
  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data,
  });

  return (
    <KTCardBody style={{padding: '1px'}}>
      <div style={{overflowX: 'auto'}}>
        <table
          id='kt_table_resellers'
          style={{
            width: '100%',
            borderSpacing: '0',
            borderCollapse: 'collapse',
            color: '#000',
            fontSize: '10px',
          }}
          {...getTableProps()}
        >
          <thead>
            <tr style={{textAlign: 'start', fontWeight: 'bold', fontSize: '12px', textTransform: 'uppercase', borderBottom: '2px solid #ccc'}}>
              {headers.map((column: ColumnInstance<Reseller>) => (
                <CustomHeaderColumn key={column.id} column={column} />
              ))}
            </tr>
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row: Row<Reseller>, i) => {
                prepareRow(row);
                return (
                  <tr
                    {...row.getRowProps()}
                    key={`row-${i}-${row.id}`}
                    style={{
                      cursor: 'default',
                      backgroundColor: '#f9f9f9',
                      transition: 'background-color 0.3s',
                      borderBottom: '1px solid #ddd',
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#e3f2fd')}
                    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#f9f9f9')}
                  >
                    {row.cells.map((cell) => (
                      <td
                        {...cell.getCellProps()}
                        style={{
                          padding: '8px',
                          borderBottom: '1px solid #ddd',
                          textAlign: 'left',
                        }}
                      >
                        {cell.render('Cell')}
                      </td>
                    ))}
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={7} style={{padding: '16px', textAlign: 'center', color: '#999'}}>
                  <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    No matching records found
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <ResellersListPagination />
      {isLoading && <ResellersListLoading />}
    </KTCardBody>
  );
};

export {ResellersTable};
